import(/* webpackMode: "eager" */ "/vercel/path1/app/toefl/vocabulary/quiz/page.tsx");
